import config from 'constants/config'
import { useIntl } from 'react-intl'
import { getPlural } from 'lib/string/pluralize'

interface Props {
  points: number
  abbreviated?: boolean
}

function FormatLoyaltyPoints({ points, abbreviated }: Props) {
  const intl = useIntl()
  const singular = abbreviated ? config.loyalty.pointsUnitAbbreviation : config.loyalty.pointsUnit
  return <>{intl.formatMessage(
    {
      id: 'Yg_Azub_H8AR6ZwAEJRn',
      defaultMessage: '{count, plural, one {# {singular}} other {# {plural}}}',
      description: 'Loyalty points count with dynamic unit from config',
    },
    { count: points, singular, plural: getPlural(singular) },
  )}
  </>
}

export default FormatLoyaltyPoints
